<template>
  <div class="about">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <h1 class="title">
              General Terms &amp; Conditions
            </h1>
          </div>

          <h2>LUDIMOS B.V.</h2>
          <p>
            Please read these General Terms and Conditions carefully before
            accessing or using our website. By accessing or using any part of
            the site, you agree to be bound by these General Terms. If you do
            not agree to all the terms and conditions of this agreement, then
            you may not access the website or use any services. If these General
            Terms are considered an offer, acceptance is expressly limited to
            these General Terms and Conditions.
          </p>
          <p>
            Any new features or tools which are added to the Products shall also
            be subject to the General Terms and Conditions. You can review the
            most current version of this document at any time on this page. We
            reserve the right to update, change or replace any part of these
            General Terms and Conditions by posting updates and/or changes to
            our website. We advise you to keep an eye on possible changes and to
            check this page periodically for changes.
          </p>

          <b>1. General Terms</b>
          <p>
            1.1 The website, located at
            <a href="https://ludimos.com">www.ludimos.com</a> and incorporating
            our web app <span>(Website) </span> 
            <a href="https://app.ludimos.com">app.ludimos.com</a>, and the
            associated application known as Ludimos App, (Application), are
            owned and operated by LUDIMOS B.V., with seat In de Wolken 226,
            1186EP Amstelveen, The Netherlands.
          </p>
          <p>
            1.2 By downloading, installing, displaying or using the Website
            and/or Application, you agree to be bound by the terms and
            conditions set out below (Terms of Use).
          </p>
          <p>
            1.3 In these Terms of Use, any reference to "we" or "us" is a
            reference to LUDIMOS B.V.
          </p>
          <b>2. Registration and Use</b>
          <p>
            2.1 You may use the Website and/or Application to view information
            and material and participate in online trainings, online coaching
            sessions, online courses and programs, digital learning. (Products).
          </p>
          <p>
            2.2 The subscription to the utilization of the Products, is
            conditional to your registration as a user (Member) and the creation
            of an account (Account).
          </p>
          <p>
            2.3 In order to create an account and use the Products you should be
            at least thirteen (13) years old or provide the consent of your
            parents or legal guardians.
          </p>
          <p>
            2.4 The use of the Website and Application is allowed for personal
            use or for professional/business use. In this second case, we offer
            a special – business- subscription, specific General terms and
            Conditions apply to this business subscription.
          </p>
          <p>
            2.5 You may access the Website and Application at any time, unless
            we have restricted access to perform necessary maintenance, updates
            or upgrades. Your ability to access the Website and Application can
            depend on factors outside our control, and we do not guarantee that
            the Website and Application will be available at all times or accept
            any responsibility for factors outside our control such as the
            quality of your internet connection, the type of computer or mobile
            device used to access the Website or others.
          </p>
          <p>
            2.6 You acknowledge that you have no rights in, or to, the Website
            or Application or technology used to support the Website or
            Application, other than the right to utilize the Website and
            Application in accordance with these General Terms and Conditions.
          </p>
          <p>
            2.7 You are responsible for maintaining the confidentiality of your
            account, password and other information and for restricting access
            to your device to further help protect such information.
          </p>
          <p>
            2.8 You agree to provide accurate and complete information when
            registering to create your Account.
          </p>
          <b>3. Subscriptions</b>
          <p>
            3.1 LUDIMOS’ Products are provided in good faith and are designed to
            promote sport- and athletic-skills.
          </p>
          <p>
            3.2 Paid Subscriptions must be paid online through the Website/App,
            through direct payment to us, following receipt of an invoice or a
            secure payment site. The prices advertised for Memberships are
            current at the time of display but may be changed by us at any time.
            Any changes to the membership’s prices will be effective from the
            date published and apply to all new memberships or renewals of
            subscriptions. All prices are advertised in USD.
          </p>
          <p>
            3.3 (a) We offer different memberships to access our Products: 1)
            One time: for a single online session with an expert coach; or 2)
            Yearly Subscription.
          </p>
          <p>
            3.4 You can register to LUDIMOS for free and acquire limited access
            to the content of our Website, by registering.
          </p>
          <p>
            3.5 Alternatively, you can purchase a paid subscription to our
            products from the Website, allowing you to access the full content.
          </p>
          <p>
            3.5 You agree to promptly notify LUDIMOS of any changes to the
            chosen payment method, while any subscriptions remain outstanding.
            You are responsible for all applicable fees and charges incurred,
            including applicable taxes, and all subscriptions purchased by you.
          </p>
          <p>
            3.6 We reserve the right to accept, cancel or reject any
            subscription for Products for any reason including, without
            limitation, where the Product is not available, there is an
            interference or disruption with the Website, or the Subscription has
            been made in breach of these Terms of Use. You acknowledge that,
            subject to us refunding any payment received from you and to the
            extent permitted by law, you have no right or claim against us for
            any loss, damage, cost or expense arising from our cancellation or
            rejection of any Subscriptions for a Product.
          </p>
          <b>4. Limitations on Use</b>
          <p>
            4.1 By accessing and using the Website or App you warrant and agree
            that you will:
          </p>
          <p>
            (a) not use the Website or App for any purpose not permitted under
            the General Terms and Conditions;
          </p>
          <p>
            (b) not utilize the Website or App for any commercial purpose
            without our prior written consent;
          </p>
          <p>
            (c) not modify, copy, transmit, distribute, reproduce, license,
            alter, reverse engineer, adapt, the whole or any part of the Website
            or App in any way whatsoever;
          </p>
          <p>
            (d) not hide, deface, alter or delete any copyright symbol,
            trademark or other proprietary rights notice;
          </p>
          <p>
            (e) not utilize the Website or App for any activity which can be
            deemed obscene, offensive or defamatory;
          </p>
          <p>
            (f) not hack into, modify or otherwise knowingly upload a virus or
            otherwise damage the Website or App or any information contained
            within it;
          </p>
          <p>
            (g) refrain from uploading onto the Website any material, or use the
            Website or Application in any way which:
          </p>
          <p>
            (i) infringes the intellectual property rights of any person; or
          </p>
          <p>(ii) is unlawful or violates any law;</p>
          <p>
            (j) not breach any other terms of the General Term and Conditions or
            our
            <router-link to="/privay-policy">
              Privacy Policy.
            </router-link>
          </p>
          <b>5. Technical information and Security</b>
          <p>
            5.1 Due consideration should be given to the fact that the
            transmission of data over the internet and/or cellular network is
            not always secure. Although we undertake our best efforts to secure
            the Website and Application, the utilization and access to the
            Website takes place at your own risk. LUDIMOS does not accept no
            responsibility for any loss, damage, or disruption to your computer
            or mobile device or otherwise arising in connection with your use of
            the Website.
          </p>
          <p>
            5.2 More specifically you acknowledge that it is your responsibility
            to implement sufficient procedures and virus checks (including
            anti-virus and other security checks) to satisfy your particular
            requirements for the accuracy of data input and output; and to
            ensure that whatever program you select for your use on the Website
            is free of viruses of anything else that may interfere with or
            damage the operations of your computer of mobile device.
          </p>
          <p>
            5.3 No guarantee is provided that functions available on the Website
            will be uninterrupted or error free, free of viruses or programming
            bugs or interferences due to factors outside our control.
          </p>
          <b>6. Intellectual Property</b>
          <p>
            6.1 The Website and Application contains intellectual property
            including but not exclusively trademarks, copyrights, designs and
            confidential information.
          </p>
          <p>
            6.2 All intellectual property on the Website and Application is
            owned by LUDIMOS or its licensors and unless permitted by law, you
            shall refrain from:
          </p>
          <p>
            (a) modifying, adapting, reproducing, storing, distributing,
            transmitting, printing, displaying, performing, publishing or
            creating derivative works from any part of the Website or
            Application; or
          </p>
          <p>
            (b) commercialising any information, products or services obtained
            from any part of Website or Application without our prior written
            consent.
          </p>
          <p>
            6.2 You guarantee that all information and material provided and
            uploaded by you does not infringe any third party rights. You shall
            indemnify and hold Ludimos, its licensors, subsidiaries, affiliates,
            officers, directors, employees, attorneys and agents harmless from
            and against any and all claims, costs, damages, losses, liabilities
            and expenses, including legal fees and costs, arising out of or in
            connection with a claim alleging that use of the Content infringes
            the rights of, or has caused harm to, a third party. Any material or
            content allegedly infringing the intellectual property law or other
            rights of third parties will be immediately deleted by Ludimos.
          </p>
          <b>7. License</b>
          <p>
            7.1 You hereby grant Ludimos and its licensees, distributors,
            agents, independent contractors, representatives and other
            authorized users, a perpetual, non-exclusive, irrevocable,
            royalty-free, sub-licensable and transferable (in whole or part)
            worldwide license to all copyrights, trademarks, patents, trade
            secrets, and other intellectual property rights you own or control
            to use, reproduce, transmit, display, exhibit, distribute, index,
            comment on, modify, create derivative works based upon, perform and
            otherwise exploit such User Content, in whole or in part, in all
            media formats and channels now known or hereafter devised, in the
            broadest sense, for any and all purposes including entertainment,
            news, advertising, promotional, marketing, commercial purposes, all
            without further notice to you, with or without attribution, and
            without the requirement of any permission from or payment to you or
            to any other person or entity. You appoint us as your agent with
            full power to enter into and execute any document and/or do any act
            we may consider appropriate to confirm, fully utilize, or enforce
            the grant of rights, consents, agreements, assignments and waivers
            set forth in this Agreement.
          </p>
          <b>8. Limitation of responsibility</b>
          <p>
            8.1 We do not guarantee, represent or warrant that your use of our
            service will be uninterrupted, timely, secure or error-free. We do
            not warrant that the results that may be obtained from the use of
            the service will be accurate or reliable
          </p>
          <p>
            8.2 We are not responsible and cannot be held accountable for the
            correctness, completeness or accuracy of the information made
            available on this site. The material on this site is provided for
            general information only and should not be relied upon or used as
            the sole decision basis, without prior consultation of more
            accurate, complete or more timely sources of information. The
            information, courses and programs provided on the Website are
            intended for the benefit of the general public and are not medical
            advice or intended to replace or substitute advice from a qualified
            health care professional.
          </p>
          <b>9. Third Party Websites and Apps</b>
          <p>
            9.1 The Website contain links to websites and apps owned and
            operated by third parties. We are not responsible for the operation,
            security levels, content or any other aspect of any third party
            websites and mobile apps.
          </p>
          <p>
            9.2 Links to third party websites and mobile apps are provided
            solely for your convenience and do not indicate our endorsement or
            affiliation of them or their products and services.
          </p>
          <p>
            9.3 We make no representations or warranties and are not liable for
            the content or accuracy of any information contained in linked
            websites and apps and third party websites and apps; or any loss or
            damage suffered as a result of access to, or use of, these third
            party websites and mobile apps, or the reliance on the information
            contained within.
          </p>
          <p>
            9.4 Third party websites and apps may be governed by their own terms
            and conditions (including their privacy policy), which will apply to
            your use and acquisition of their products or services. Accordingly,
            we strongly recommend that you read the terms and conditions of
            these parties.
          </p>
          <p>
            9.5 You agree to indemnify, defend and hold harmless LUDIMOS and our
            parent, subsidiaries, affiliates, partners, from any claim or
            demand, including reasonable attorneys’ fees, made by any
            third party due to or arising out of your breach of these General
            Terms and Conditions or your violation of any law or the rights of a
            third party.
          </p>
          <b>10. Suspension or Termination</b>
          <p>
            10.1 The obligations and liabilities of the parties incurred prior
            to the termination date shall survive the termination of this
            agreement for all purposes. These General Terms and Conditions are
            effective unless and until terminated by either you or us.
          </p>
          <p>
            10.2 We reserve the right to suspend or terminate your access to the
            Website and App at our sole discretion, including if we believe
            there has been a breach of these General Terms and Conditions.
          </p>
          <p>
            10.3 We reserve the right to cease operating the Website and/or App
            at any time, without notice, and to terminate this agreement under
            the General Terms and Conditions.
          </p>
          <p>
            10.4 You may terminate the subscription at any time. Cancellation is
            effective at the end of the applicable yearly period. Please make
            any such cancellation by emailing
            <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>.
          </p>
          <b>11. Privacy</b>
          <p>
            11.1 You acknowledge that information about you, including
            information provided upon becoming a Registered User and creating an
            Account will be collected, held and used by us in accordance with
            our Privacy Policy
          </p>
          <b>12. General</b>
          <p>
            12.1 We reserve the right to amend, modify, add, delete and make
            corrections to the General Terms and Conditions at any time.
          </p>
          <p>
            12.2 These General Terms and Conditions are governed by and
            construed in accordance with the laws of the Netherlands. Any claim
            made by either party against the other which in any way arises out
            of the General Terms and Conditions will have to be submitted to the
            jurisdiction of the District Court of Amsterdam.
          </p>
          <p>
            12.3 For further information on using the Website and Application,
            please contact
            <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
          </p>
          <p>Last updated on June 3, 2020.</p>

          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GeneralTermsAndConditions",
  metaInfo() {
    return {
      title: this.textEllipsis(`General Terms & Conditions`, 25),
    };
  },
};
</script>
